/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router';
import { getAllStates, updateState, saveState, getAllCountries } from '../../../services/getLocationList';
import useLoader from '../../../utils/useLoader';
import { validateLocationData, getValueDropdown } from '../../../utils/utils';
import { validateField } from "../../../utils/utils";
import MainSelect from '../../atoms/main-select/MainSelect';
import { informationAlert } from '../../molecules/alert/alert';
import InputSearchSet from '../../molecules/input-search-set/InputSearchSet';
import TablePagination from '../../molecules/table-pagination/TablePagination';
import Table from '../../molecules/table/Table';
import './manageStates.scss';
import { useTranslation } from "react-i18next";
import manageStatesConstants from '../../../constants/manage-states';
import TranslationComponentConstants from '../../../constants/translation-language-constants';
import Toolkit from '../../atoms/toolkit/Toolkit';
import { PdsButton, PdsDropdown, PdsDropdownOption, PdsInput } from '@pragma-dev-kit/pragma-ds-react';


function ManageStates({ props }) {
    const constants = manageStatesConstants;
    const translationConstants = TranslationComponentConstants;

    let keyword, pageNo, pageSize, sortBy, ascSort;

    const history = useHistory();
    const [loader, showLoader, hideLoader] = useLoader();
    const [translate] = useTranslation(translationConstants.USE_TRANSLATION_GLOBAL_VALUE);

    const selectValues = [
        { value: constants.TEN_ROWS, label: `${constants.TEN_ROWS_LABEL} ${translate('components.table.resultsPerPage')}` },
        { value: constants.TWENTY_ROWS, label: `${constants.TWENTY_ROWS_LABEL} ${translate('components.table.resultsPerPage')}` },
        { value: constants.FIFTY_ROWS, label: `${constants.FIFTY_ROWS_LABEL} ${translate('components.table.resultsPerPage')}` }
    ];

    const initialData = {
        paisId: constants.EMPTY_STRING_INITIAL_VALUE,
        estado: constants.EMPTY_STRING_INITIAL_VALUE
    }


    const headingColumns = [
        { key: constants.DEPARTMENT_COLUMN, val: translate('administrator.manageStates.state'), width: constants.WIDTH_COLUMN_3 },
        { key: constants.COUNTRY_COLUMN, val: translate('administrator.manageStates.country'), width: constants.WIDTH_COLUMN_3 },
    ];

    const [edit, setEdit] = useState(false);
    const [paises, setPaises] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [errors, setErrors] = useState({});
    const [selected, setSelected] = useState(initialData);
    const [resetKey, setResetKey] = useState(constants.ZERO_VALUE);

    const [totalPages, setTotalPages] = useState(constants.PAGES_INITIAL_STATE_ONE);
    const [currentPage, setCurrentPage] = useState(constants.PAGES_INITIAL_STATE_ONE);
    const [searchItem, setSearchItem] = useState(constants.EMPTY_STRING_INITIAL_STATE);
    const [requestsPerPage, setRequestsPerPage] = useState(constants.REQUESTS_INITIAL_STATE_TWENTY);
    const [orderBy, setOrderBy] = useState({ nameColumn: constants.DEPARTMENT_COLUMN, orderAsc: true });

    const dropdowns = document.querySelectorAll(constants.DROPDOWN_SELECTOR);
    dropdowns.forEach(dropdown => {
        const dropdownElement = dropdown.shadowRoot.querySelector(constants.DROPDOWN_CLASS);
        if (dropdownElement) {
            dropdownElement.style.cssText = `
                    ${constants.DROPDOWN_WIDTH}
                `;
        }
    });

    useEffect(() => { reloadTable() }, [currentPage, requestsPerPage, orderBy, searchItem]);

    useEffect(() => { getAllCountries().then(res => { setPaises(res) }).catch(error => { console.error(constants.ERROR_LABEL, error) }) }, [])

    useEffect(() => {
        showLoader();
        const dataSend = `${constants.KEYWORD_PARAM}${searchItem}${constants.PAGE_NO_PARAM}${currentPage - constants.ONE_VALUE}${constants.PAGE_SIZE_PARAM}${requestsPerPage}${constants.SORT_BY_PARAM}${orderBy.nameColumn}${constants.SORT_ASC_PARAM}${orderBy.orderAsc}`;
        if (window.location.search === constants.EMPTY_STRING_VALUE) {
            getAllStates(dataSend).then(response => {
                setTotalPages(response.totalPages);
                setTableData(response.resultList.slice());
                hideLoader();
            }).catch(error => {
                hideLoader();
                setTableData([]);
                informationAlert(constants.ERROR_LABEL, translate('alerts.oops'), error);
            })
        } else {
            separatePastParams(window.location.search);
        }
    }, []);

    const validate = async () => {
        const dataSend = {
            id: selected.estadoId,
            name: selected.estado,
            country_id: selected.paisId
        }
        try {
            validateLocationData(constants.STATE_LABEL, selected, () => {
                showLoader();
                if (dataSend.id) {
                    callUpdateState(dataSend);
                } else {
                    callSaveState(dataSend)
                }
            })
        } catch (e) {
            informationAlert(e.type, e.msg, e.details);
            return false;
        }
        limpiar();
    }

    const callUpdateState = dataSend => {
        updateState(dataSend).then(response => {
            hideLoader();
            switch (response.data.status) {
                case constants.STATUS_CODE_200:
                    informationAlert(constants.SUCCESS_LABEL, translate('alerts.success'), response.data.userMessage);
                    setSelected(initialData);
                    setEdit(false);
                    reloadTable();
                    break;
                default:
                    informationAlert(constants.ERROR_LABEL, translate('alerts.oops'), response.data.userMessage);
                    break;
            }
        }).catch(err => {
            hideLoader();
            throw ({ type: constants.ERROR_LABEL, msg: translate('alerts.oopsWrong'), details: constants.EMPTY_STRING_VALUE });
        })
    }

    const callSaveState = dataSend => {
        saveState(dataSend).then(response => {
            hideLoader();
            switch (response.data.status) {
                case constants.STATUS_CODE_200:
                    informationAlert(constants.SUCCESS_LABEL, translate('alerts.success'), response.data.userMessage);
                    setSelected(initialData);
                    reloadTable();
                    break;
                default:
                    informationAlert(constants.ERROR_LABEL, translate('alerts.oops'), response.data.userMessage);
                    break;
            }
        }).catch(err => {
            hideLoader();
            throw ({ type: constants.ERROR_LABEL, msg: translate('alerts.oopsWrong'), details: constants.EMPTY_STRING_VALUE });
        })
    }

    const handleOnchangeSearch = (event) => {
        setSearchItem(event.target.value);
    }

    const handleOnclickDataHeading = (nameTableColumn) => {
        let orderByVal = nameTableColumn === orderBy.nameColumn ? !orderBy.orderAsc : true;
        setOrderBy({ nameColumn: nameTableColumn, orderAsc: orderByVal });
    }

    const handleOnItemClickListener = (row) => {
        setEdit(true);
        setSelected({ estadoId: row.departamentoId, paisId: row.paisId, estado: row.departamento });
        window.scrollTo(constants.ZERO_VALUE, constants.ZERO_VALUE);
    }

    const handleOnchange = (requestPerPage) => {
        setRequestsPerPage(requestPerPage);
        setCurrentPage(constants.FIRST_PAGE);
    }

    const handleOnclick = (newPage) => {
        if (newPage >= constants.ONE_VALUE && newPage <= totalPages) setCurrentPage(newPage);
    }

    const reloadTable = () => {
        const filterData = `${constants.KEYWORD_PARAM}${searchItem}${constants.PAGE_NO_PARAM}${currentPage - constants.ONE_VALUE}${constants.PAGE_SIZE_PARAM}${requestsPerPage}${constants.SORT_BY_PARAM}${orderBy.nameColumn}${constants.SORT_ASC_PARAM}${orderBy.orderAsc}`;
        showLoader();
        getAllStates(filterData).then(response => {
            setTotalPages(response.totalPages);
            setTableData(response.resultList.slice());
            hideLoader();
        }).catch(error => {
            hideLoader();
            setTableData([]);
            informationAlert(constants.ERROR_LABEL, translate('alerts.oops'), error);
        });
    }

    const separatePastParams = (url) => {
        const search = url.split(constants.EQUALS);
        keyword = (search[constants.SECOND_INDEX_POSITION].split(constants.AMPERSAND))[constants.FIRST_INDEX_POSITION];
        pageNo = (search[constants.THIRD_INDEX_POSITION].split(constants.AMPERSAND))[constants.FIRST_INDEX_POSITION];
        pageSize = (search[constants.FOURTH_INDEX_POSITION].split(constants.AMPERSAND))[constants.FIRST_INDEX_POSITION];
        sortBy = (search[constants.FIFTH_INDEX_POSITION].split(constants.AMPERSAND))[constants.FIRST_INDEX_POSITION];
        ascSort = search[constants.SIXTH_INDEX_POSITION];
        setRequestsPerPage(pageSize);
        setSearchItem(keyword);
        setCurrentPage(parseInt(pageNo));
        setOrderBy({ nameColumn: sortBy.toString(), orderAsc: ascSort });
    }

    const limpiar = () => {
        setEdit(false);
        setSelected(initialData);
        setResetKey(prevKey => prevKey + constants.ONE_VALUE);
    }

    const getCountryInfo = (value) => paises.filter((country) => country.name === value.detail || country.id === Number(value.detail))[constants.ZERO_NUMBER];

    const actualizarData = (fragment, event) => {
        if (fragment === constants.COUNTRY_ID_LABEL) {
            setSelected({ ...selected, [fragment]: event })
            return;
        }
        const value = event.detail ? event.detail : event.target.value;
        setSelected({ ...selected, [fragment]: value })
    }

    const actualizarLocation = (location, event) => {
        const value = event.detail ? event.detail : event.target.value;
        if (location === constants.COUNTRY_LABEL) {
            if (value !== constants.ZERO_STRING || Number(value) !== constants.ZERO_NUMBER) {
                const selectedCountry = getCountryInfo(event);
                actualizarData(constants.COUNTRY_ID_LABEL, selectedCountry.id);
            }
        }
    }

    const handleOnInput = (event) => {
        const { name, value } = event.target;
        actualizarData(constants.STATE_LABEL, event)
    
        const fieldErrors = validateField(name, value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldErrors,
        }));
    };

    const getCities = () => {
        const filterData = `${constants.KEYWORD_PARAM}${selected.estado}${constants.FILTERED_PARAM}`;
        history.push(`${constants.CITIES_PATH}${filterData}`)
    }

    const getValuesDropdown = useCallback((key, value, list) => {
        return getValueDropdown(key, value, list);
    },[selected]);   

    return (
        <Fragment>
            <Toolkit>
                <div className='states-toolkit__search'>
                    <InputSearchSet
                        type="text"
                        placeholder={translate('transversal.search')}
                        value={searchItem}
                        onChange={handleOnchangeSearch}
                    />
                </div>
            </Toolkit>
            <div className="form__content edit__location2">
                <div className="information">
                    <div>
                        <h3 className='information__title'>{`${edit ? translate('transversal.edit') : translate('transversal.create')} ${translate('administrator.manageStates.state')}`}</h3>
                    </div>
                    <div key={resetKey} className="form__input">
                        <PdsDropdown
                            className={selected.paisId !== constants.EMPTY_STRING_VALUE ? 'input-value' : ''}
                            name='pais'
                            value={selected.paisId}
                            onValueChange={event => actualizarLocation('pais', event)}
                            placeholder={getValuesDropdown("id", parseInt(selected.paisId), paises) ||  translate('transversal.selectOption')}
                            label={translate('administrator.manageStates.country')}
                        >
                            {paises.map((country) => (
                                <PdsDropdownOption theme="dark" key={country.id} value={country.name}>
                                    {country.name}
                                </PdsDropdownOption>
                            ))}
                        </PdsDropdown>
                        <PdsInput
                            className='input__state'
                            name='estado'
                            value={selected.estado}
                            onInput={handleOnInput}
                            label={translate('administrator.manageStates.state')}
                            {...(errors.estado || {})}
                        />
                    </div>
                    <div className="form__button">
                        <PdsButton
                            className='manage-states__button-clean'
                            name={translate('transversal.clean')} 
                            onClick={limpiar}
                        >
                            {translate('transversal.clean')}
                        </PdsButton>
                        <PdsButton
                            className='manage-states__button-edit'
                            name={edit ? translate('transversal.edit') : translate('transversal.create')}
                            onClick={validate}
                        >
                            {edit ? translate('transversal.edit') : translate('transversal.create')}    
                        </PdsButton>
                    </div>
                </div>
            </div>
            <Table
                tableData={tableData}
                headingColums={headingColumns}
                title={null}
                breakOn='medium'
                orderBy={handleOnclickDataHeading}
                orderColumnName={orderBy.nameColumn}
                orderColumnDirection={orderBy.orderAsc}
                onItemClickListener={handleOnItemClickListener}
            />
            <div className="o-footer__table">
                <MainSelect
                    options={selectValues}
                    name={`invoicetable`}
                    value={requestsPerPage}
                    onChange={handleOnchange}
                />
                <TablePagination
                    paginate={(event, newPage) => handleOnclick(newPage)}
                    pageAmount={totalPages}
                    currentPage={currentPage}
                />
            </div>
            {loader}
        </Fragment>
    )
}

export default ManageStates;